<template>
    <div>
        <!-- 头部组件 -->
        <HeaderPage href="/products" />

        <!-- 面包屑导航（动态渲染当前页面名称） -->
        <div class="bread">
            <div class="wrap">
                <router-link to="/">首页</router-link>
                &gt; <router-link to="/companynews?id=3">网上信息公开</router-link>
                &gt; <router-link to="/companynews?id=3">{{ currentDetail?.title }}</router-link>
            </div>
        </div>

        <div class="newsView">
            <div class="wrap">
                <div class="newsHead wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <h1>{{ currentDetail?.title}}</h1>
                    <dd><span>时间:  {{ formatTime(currentDetail?.releaseTime)}}</span><span>作者: 国正</span></dd>
                </div>

                <div class="text wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <!-- 加载状态 -->
                    <div v-if="isLoading" class="loading-state">
                        <p>正在加载内容...</p>
                    </div>

                    <!-- 错误状态 -->
                    <div v-else-if="hasError" class="error-state">
                        <p>内容加载失败，请稍后重试</p>
                    </div>

                    <!-- 富文本内容渲染 -->
                    <div v-else-if="currentDetail?.content"  class="rich-content" v-html="currentDetail.content"></div>

                    <!-- 无内容状态 -->
                    <div v-else class="no-content">
                        <p>暂无内容</p>
                    </div>
                </div>
                <!-- <router-link> href="/products">返回</router-link> -->
            </div>
        </div>
        <!-- 底部组件 -->
        <FooterPage />
    </div>
</template>

<script setup>
// 1. 引入所需依赖
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
// import axios from 'axios'
import { getWebsiteData } from '@/utils/api';
import { formatTime } from '@/utils/index';


const route = useRoute()


const currentDetail = ref({}) // 存储接口返回的详情数据（标题、内容等）
const isLoading = ref(true) // 加载状态
const hasError = ref(false) // 错误状态



// 4. 页面挂载时执行接口请求
onMounted(async() => {
    try {
        isLoading.value = true
        hasError.value = false

        // mock
        // const res = await axios.get('/mock/productList.json'); // 本地Mock文件路径
        // if (res.data.code === 200) {
        //     currentDetail.value = res.data.data.find(item => item.id === detailId)
        // }
        const params = {
            id: route.query.id
        };
        const res = await getWebsiteData(params);

        if (res.data && res.data.list && res.data.list.length > 0) {
            currentDetail.value = res.data.list[0]
        } else {
            hasError.value = true
        }

    } catch (err) {
        console.error('获取失败：', err);
        hasError.value = true
    } finally {
        isLoading.value = false
    }
})
</script>

<style>
/* 原有样式保留，新增加载/错误状态样式 */
.bread {
    line-height: 70px;
    color: #666;
    margin-top: 140px;
}

.bread a {
    color: #666;
    text-decoration: none;
}

.newsView {
    padding: 60px 0 100px;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 14px;
}

th,
td {
    border: 1px solid #ccc;
    padding: 8px 10px;
    text-align: center;
}

th {
    background: #f2f2f2;
}

/* 加载状态样式 */
.loading-state {
    text-align: center;
    padding: 50px 0;
    color: #666;
    font-size: 16px;
}

/* 错误状态样式 */
.error-state {
    text-align: center;
    padding: 50px 0;
    color: #ff4d4f;
}

.back-btn {
    display: inline-block;
    margin-top: 20px;
    color: #42b983;
    text-decoration: none;
    border: 1px solid #42b983;
    padding: 8px 16px;
    border-radius: 4px;
}

/* 返回链接样式优化 */
.back-link {
    display: inline-block;
    margin-top: 30px;
    color: #42b983;
    text-decoration: none;
}

.back-link:hover {
    text-decoration: underline;
}

/* 富文本内容样式 */
.rich-content {
    line-height: 1.8;
    color: #333;
    font-size: 16px;
    word-wrap: break-word;
}

.rich-content p img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 20px auto;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 富文本内图片样式 */
.rich-content img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 20px auto;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 富文本内段落样式 */
.rich-content p {
    margin: 16px 0;
    text-align: justify;
}

/* 富文本内标题样式 */
.rich-content h1,
.rich-content h2,
.rich-content h3,
.rich-content h4,
.rich-content h5,
.rich-content h6 {
    margin: 24px 0 16px 0;
    font-weight: bold;
    color: #2c3e50;
}

/* 富文本内列表样式 */
.rich-content ul,
.rich-content ol {
    margin: 16px 0;
    padding-left: 24px;
}

.rich-content li {
    margin: 8px 0;
}

/* 富文本内链接样式 */
.rich-content a {
    color: #42b983;
    text-decoration: none;
}

.rich-content a:hover {
    text-decoration: underline;
}

/* 富文本内代码样式 */
.rich-content code {
    background-color: #f5f5f5;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
}

.rich-content pre {
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 4px;
    overflow-x: auto;
    margin: 16px 0;
}

/* 富文本内表格样式 */
.rich-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
}

.rich-content th,
.rich-content td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
}

.rich-content th {
    background-color: #f8f9fa;
    font-weight: bold;
}

/* 富文本内引用样式 */
.rich-content blockquote {
    border-left: 4px solid #42b983;
    margin: 16px 0;
    padding: 16px 20px;
    background-color: #f8f9fa;
    font-style: italic;
}

/* 无内容状态样式 */
.no-content {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 16px;
}
</style>
